import React, { Component } from "react";
import { getMessage } from "CONFIG/i18n";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import moment from 'moment';
import Pagination from "react-js-pagination";
import { withOrientationChange, isMobileOnly } from "react-device-detect";
import { Input, Col } from "reactstrap";

import { getBootstrapTableOptions } from "UTILS/Utility";
// ASSETS
import icBack from "ASSETS/Images/back.svg";
import icEclipse from "ASSETS/Images/ic_eclipse.svg";
import icCheck from "ASSETS/Images/ic_check.svg";
import icCustomerManagement from "ASSETS/Images/menu_icons/icon_waiting.svg";

// UTILS
import { PAGE_COUNT, MODAL_TYPE } from "UTILS/Constants";

// STYLESHEET
import "./WaitingUsers.less";

class WaitingUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSessionId: null,
      intervalId: null,
      displayPage: this.props.waitingUsersData.displayPage + 1,
      sessionListPageSize: Number(this.props.waitingUsersData.sessionListPageSize)
    };
  }

  componentDidMount() {
    this.state.intervalId = setInterval(() => {
      this.getWaitSessionsList();
    }, 1000 * 10);
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  backYesHandle = () => {
    this.props.backToMenu();
  }

  selectRow = (cell, row) => {
    return (
      row.session_key === this.state.selectedSessionId
        ? <img src={icCheck} /> : <img src={icEclipse} />
    );
  }

  holdingDate = (cell, row) => {
    return (
      <div className="d-flex flex-column">
        <span>{moment(row.created_time).format("YYYY/MM/DD HH:mm:ss")}</span>
      </div>
    );
  }

  // handle failure to cancel and start meeting
  handleMeetingError = (errorMessage) => {
    this.setState({
      modalMessage: getMessage(errorMessage),
      modalType: MODAL_TYPE.FAILURE
    }, () => {
      this.fetchTableData();
    });
  }

  onRowSelect = (row, isSelected, e) => {
    this.setState({
      selectedSessionId: this.state.selectedSessionId !== row.session_key ? row.session_key : ""
    });
  }

  changePage = (displayPage) => {
    this.state.displayPage !== displayPage &&
    this.setState({
      displayPage,
      selectedSessionId: null
    }, () => this.getWaitSessionsList());
  }

  changePageCount = (event) => {
    this.setState({ sessionListPageSize: Number(event.target.value), displayPage: 1 },
      () => this.getWaitSessionsList());
  }

  getWaitSessionsList = () => {
    this.props.getWaitSessionsList(
      this.state.sessionListPageSize,
      this.state.displayPage - 1
    );
    const tableData = document.querySelector("#waitingUsers .react-bs-container-body");
    if (tableData) {
      tableData.scrollTop = 0;
    }
  }

  allFormat = (cell, row) => {
    return (
      <>
        <div className="d-flex flex-column">
          <span>{moment(row.created_time).format("YYYY/MM/DD HH:mm:ss")}</span>
        </div>
        <div><span>{row.session_name}</span></div>
      </>
    );
  }

  // Color the lines
  rowClassNameFormat = (row, rowIndex) => {
    const date = new Date();
    const diffTime = new Date(date.setMinutes(date.getMinutes() - 2));
    return (new Date(row.created_time) < diffTime) ? "table-danger" : "";
  }

  render() {
    const selectRowProp = {
      mode: 'radio',
      clickToSelect: true,
      hideSelectColumn: true,
      onSelect: this.onRowSelect,
      bgColor: "#FFF5E6"
    };
    return (
      <>
        <div className="col-xl-2 col-12 d-flex align-items-center backBtn pl-3 pt-2">
          <img src={icBack} className="pr-2 cursorPointer" onClick={this.backYesHandle} />
          <span className="cursorPointer" onClick={this.backYesHandle}>{getMessage("BACK_TO_MENU")}</span>
        </div>
        <div className="container waitingUsers">
          <div className="col-12 col-xl-6 offset-xl-3 d-flex justify-content-center">
            <div className="col-5 col-sm-3 p-0 d-flex flex-column">
              <div className="row">
                <div className="col-sm-12 text-center">
                  <img
                    src={icCustomerManagement}
                    className="img-fluid session-img createSessionImage"
                    alt="Start Session"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center pb-4">
              <span className="sessionMenuTitle">{getMessage("QR_WAITING_USERS")}</span>
            </div>
          </div>
          {this.props.waitSessionsDetails && this.props.waitSessionsDetails.sessionsList
          && this.props.waitSessionsDetails.sessionsList.length > 0 && (
            <div className="waitingUsersContainer pt-3 mx-xl-5">
              <div className="d-flex justify-content-center">
                <div className="col-xl-9 d-flex justify-content-center" id="waitingUsers">
                  <BootstrapTable
                    data={this.props.waitSessionsDetails.sessionsList}
                    id="waitingSessionsTable"
                    containerClass="waitingUsersContainer p-3"
                    bordered={false}
                    options={getBootstrapTableOptions()}
                    selectRow={selectRowProp}
                    maxHeight="450px"
                    printable
                    trClassName={this.rowClassNameFormat}
                  >
                    {/* column hidden always */}
                    <TableHeaderColumn
                      dataField="session_key"
                      searchable={false}
                      hidden
                      isKey
                    >
                      {getMessage("SESSION_KEY")}
                    </TableHeaderColumn>

                    {/* column visible for all devices */}
                    <TableHeaderColumn
                      dataField="session_key"
                      searchable={false}
                      dataFormat={this.selectRow}
                      width={isMobileOnly ? "11%" : "8%"}
                      dataAlign="right"
                      columnClassName="hide-ellipsis"
                    />

                    {/* column visible for desktop, tablet and horizontal mobile */}
                    <TableHeaderColumn
                      dataField="created_time"
                      dataFormat={this.holdingDate}
                      dataSort
                      width={this.props.isLandscape ? "30%" : "30%"}
                      hidden={isMobileOnly && !this.props.isLandscape}
                      dataAlign="left"
                    >
                      {getMessage("QR_WAITING_DATE")}
                    </TableHeaderColumn>

                    <TableHeaderColumn
                      dataField="session_name"
                      width={isMobileOnly ? "50%" : "50%"}
                      hidden={isMobileOnly && !this.props.isLandscape}
                      dataSort
                      dataAlign="left"
                    >
                      {getMessage("QR_CUSTOMER_NAME")}
                    </TableHeaderColumn>

                    {/* Column is hidden for desktop and tablet and horizontal mobile */}
                    <TableHeaderColumn
                      dataField="created_time"
                      dataAlign="left"
                      dataSort
                      hidden={!(isMobileOnly && !this.props.isLandscape)}
                      dataFormat={this.allFormat}
                    >
                      {getMessage("QR_WAITING_DATE")}
                      <br />
                      {getMessage("QR_CUSTOMER_NAME")}
                    </TableHeaderColumn>
                  </BootstrapTable>
                </div>
              </div>
            </div>
          )}

          {this.props.waitSessionsDetails && this.props.waitSessionsDetails.sessionsList
          && this.props.waitSessionsDetails.sessionsList.length === 0 && (
            <div className="text-center py-3 mx-xl-5">
              {getMessage("QR_NO_WAITING_USERS")}
            </div>
          )}

          {this.props.waitSessionsDetails.sessionsList && this.props.totalSessions > 0
          && (
            <div className={this.props.isLandscape ? "col-xl-8 offset-xl-2 d-flex px-md-auto px-0 pt-2 pb-auto pb-2 justify-content-between" : "col-xl-8 offset-xl-2 d-md-flex px-md-auto px-0 pt-2 pb-auto pb-2 justify-content-between"}>
              <div>
                {getMessage("PAGINATION_TOTAL_ENTRIES",
                  { from: (this.state.displayPage - 1) * this.state.sessionListPageSize + 1,
                    to: (this.state.displayPage - 1) * this.state.sessionListPageSize
                    + this.props.waitSessionsDetails.sessionsList.length,
                    totalCount: this.props.totalSessions })}
              </div>
              {this.props.totalSessions > this.state.sessionListPageSize && (
                <Pagination
                  activePage={this.state.displayPage}
                  itemsCountPerPage={this.state.sessionListPageSize}
                  totalItemsCount={this.props.totalSessions}
                  pageRangeDisplayed={3}
                  onChange={this.changePage}
                  itemClass="page-item"
                  linkClass="page-link"
                  innerClass={this.props.isLandscape ? "pagination pr-4" : "pagination"}
                />
              )}
              {/* when in mobile vertical width needs to be reduced to 25% from 100% */}
              <div className={isMobileOnly && !this.props.isLandscape ? "sessionCount w-25" : "sessionCount"}>
                <Input type="select" className="inputFormControl form-control border" onChange={this.changePageCount} value={this.state.sessionListPageSize}>
                  {
                    PAGE_COUNT.map((count) => (
                      <option key={count} value={count}>
                        {count}
                      </option>
                    ))
                  }
                </Input>
              </div>
            </div>
          )}

          {this.props.waitSessionsDetails && this.props.waitSessionsDetails.sessionsList
          && this.props.waitSessionsDetails.sessionsList.length > 0 && (
            <div className="d-flex justify-content-center">
              <Col sm={6} xl={4} className="pb-3">
                <button
                  type="button"
                  id="startBtn"
                  className="startBtn btn shadow-none rounded-pill w-100 whiteOnClick"
                  onClick={() => {
                    if (!this.state.selectedSessionId) {
                      return;
                    }
                    this.props.joinSession(this.state.selectedSessionId);
                  }}
                >
                  {getMessage("PARTICIPATE")}
                </button>
              </Col>
            </div>
          )}
        </div>
      </>
    );
  }
}

export default withOrientationChange(WaitingUsers);
